import { useQuery } from '@tanstack/react-query';
import { BillingService } from '../services';

/**
 * Hook para buscar faturas (invoices) de créditos
 */
export const useInvoices = () => {
  const {
    data: invoices,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['invoices'],
    queryFn: ({ signal }) => BillingService.getInvoices(signal),
    staleTime: 2 * 60 * 1000, // 2 minutes
  });

  return {
    invoices,
    isLoading,
    error,
    refetch,
  };
};

/**
 * Hook para buscar detalhe de uma fatura por ciclo
 */
export const useInvoiceDetail = (cycle?: number) => {
  const {
    data: invoiceDetail,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['invoice-detail', cycle],
    queryFn: ({ signal }) => BillingService.getInvoiceDetail(cycle!, signal),
    enabled: cycle !== undefined && cycle > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    invoiceDetail,
    isLoading,
    error,
    refetch,
  };
};
